import { inject } from "@angular/core";
import { Router } from "@angular/router";

import { filter, firstValueFrom } from "rxjs";
import { onboardingStatus } from "src/interface";
import { RootStore } from "../store/root.store";

export const onboardingGuard = async () => {
  const router = inject(Router);
  const rootStore = inject(RootStore);

  // Wait for userData to be loaded if it's observable
  const user = await firstValueFrom(
    rootStore.userStore.userData$.pipe(
      filter((user) => user !== null), // wait for user to be set
    ),
  );

  if (user && !rootStore.userStore.isOnboarded()) {
    switch (user.onboardingStatus) {
      case onboardingStatus.PERSONAL_INFORMATION:
        router.navigate(["/onboarding/personal-information"]);
        break;
      case onboardingStatus.ORGANIZATION:
        router.navigate(["/onboarding/organization"]);
        break;
      case onboardingStatus.PROJECTS:
        router.navigate(["/onboarding/projects"]);
        break;
      case onboardingStatus.PLAYERS:
        router.navigate(["/onboarding/players"]);
        break;
      default:
        router.navigate(["/onboarding"]);
        break;
    }
    return false;
  } else {
    return true;
  }
};
